export interface Movie {
  id: number;
  title: string;
  titleEn: string;
  category: 'movie' | 'tv' | 'variety' | 'anime';
  categoryLabel: string;
  year: number;
  rating: number;
  poster: string;
  description: string;
  director: string;
  actors: string[];
  region: string;
  duration: string;
  episodes?: number;
  status: string;
  tags: string[];
  featured: boolean;
  isNew: boolean;
  isHot: boolean;
  content: string;
  releaseDate: string;
}

export const allMovies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    titleEn: 'The Wandering Earth 3',
    category: 'movie',
    categoryLabel: '电影',
    year: 2026,
    rating: 8.5,
    poster: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20poster%20featuring%20astronauts%20and%20a%20massive%20spaceship%20against%20a%20dark%20cosmic%20backdrop%20with%20glowing%20nebula%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20clean%20simple%20background%2C%20high%20contrast%2C%20movie%20poster%20style&width=600&height=840&seq=movie-poster-01&orientation=portrait',
    description: '太阳即将毁灭，人类面临前所未有的生存危机。在地球发动机的推动下，人类踏上了长达2500年的星际流浪之旅，向着4.2光年外的新家园进发。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    region: '中国大陆',
    duration: '148分钟',
    status: '热播中',
    tags: ['科幻', '冒险', '灾难', '国产大片'],
    featured: true,
    isNew: false,
    isHot: true,
    content: '<p>《流浪地球3》延续了前两部作品的宏大世界观，讲述了人类在太阳氦闪危机下的生存抉择。影片耗资巨大，特效团队汇集了全球顶尖的视觉艺术家，打造出了震撼人心的太空场景和灾难场面。吴京和刘德华的联袂出演更是将人性的光辉与挣扎展现得淋漓尽致。</p><p>影片不仅仅是一部科幻灾难片，更是一部关于人类命运共同体的深刻思考。当地球面临毁灭，人类是选择分裂还是团结？影片用极致的视听语言给出了震撼人心的答案。</p>',
    releaseDate: '2026-01-22',
  },
  {
    id: 2,
    title: '长安十二时辰',
    titleEn: 'The Longest Day In Chang\'an',
    category: 'tv',
    categoryLabel: '电视剧',
    year: 2025,
    rating: 9.0,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20featuring%20ancient%20Tang%20Dynasty%20warriors%20in%20traditional%20armor%20with%20lanterns%20and%20ancient%20city%20walls%2C%20warm%20golden%20tones%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20clean%20simple%20background&width=600&height=840&seq=movie-poster-02&orientation=portrait',
    description: '唐朝天宝三年，上元节前夕，长安城陷入了一场巨大的危机。死囚张小敬临危受命，与靖安司司丞李必携手，在十二个时辰内阻止一场毁城阴谋。',
    director: '曹盾',
    actors: ['雷佳音', '易烊千玺', '周一围', '芦芳生'],
    region: '中国大陆',
    duration: '48集',
    episodes: 48,
    status: '已完结',
    tags: ['古装', '悬疑', '历史', '精品剧集'],
    featured: true,
    isNew: false,
    isHot: true,
    content: '<p>《长安十二时辰》改编自马伯庸同名小说，以唐朝长安城为背景，将悬疑、历史、动作元素完美融合。全剧以十二个时辰（24小时）为时间线，紧凑的叙事节奏让观众欲罢不能。</p><p>雷佳音饰演的死囚张小敬与易烊千玺饰演的少年天才李必，一文一武的搭配产生了奇妙的化学反应。剧组对唐朝文化的精准还原，从服饰、建筑到礼仪细节，无不精益求精。</p>',
    releaseDate: '2025-06-15',
  },
  {
    id: 3,
    title: '疯狂动物城2',
    titleEn: 'Zootopia 2',
    category: 'movie',
    categoryLabel: '电影',
    year: 2025,
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Animated%20movie%20poster%20featuring%20a%20rabbit%20and%20fox%20detective%20duo%20in%20a%20modern%20animal%20city%2C%20vibrant%20colors%2C%20playful%20composition%2C%20cinematic%20lighting%2C%20clean%20simple%20background%2C%20Disney%20animation%20style&width=600&height=840&seq=movie-poster-03&orientation=portrait',
    description: '兔子警官朱迪和狐狸尼克再度联手，调查一起神秘的动物失踪案。随着调查深入，他们发现这背后隐藏着一个更大的阴谋，动物城的和平再次受到威胁。',
    director: '拜伦·霍华德',
    actors: ['金妮弗·古德温', '杰森·贝特曼', '伊德瑞斯·艾尔巴'],
    region: '美国',
    duration: '108分钟',
    status: '热播中',
    tags: ['动画', '喜剧', '冒险', '迪士尼'],
    featured: true,
    isNew: true,
    isHot: true,
    content: '<p>时隔多年，迪士尼终于带来了《疯狂动物城》的续集。朱迪和尼克的搭档关系更加默契，新加入的角色也为故事增添了新的看点。影片延续了前作的高水准制作，画面精美绝伦。</p><p>影片在逗趣搞笑的同时，也延续了对社会议题的深刻探讨，让观众在欢笑中思考平等与包容的真谛。</p>',
    releaseDate: '2025-11-26',
  },
  {
    id: 4,
    title: '庆余年第二季',
    titleEn: 'Joy of Life Season 2',
    category: 'tv',
    categoryLabel: '电视剧',
    year: 2026,
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20fantasy%20drama%20poster%20featuring%20a%20young%20man%20in%20traditional%20robes%20holding%20a%20sword%2C%20ancient%20palace%20background%2C%20ethereal%20mist%2C%20dramatic%20lighting%2C%20clean%20simple%20composition&width=600&height=840&seq=movie-poster-04&orientation=portrait',
    description: '范闲从北齐归来，面对朝堂上更加复杂的权力斗争。二皇子、太子、长公主各怀心思，庆帝的心思愈发深沉难测。范闲在权谋与理想的夹缝中艰难前行。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    region: '中国大陆',
    duration: '36集',
    episodes: 36,
    status: '热播中',
    tags: ['古装', '权谋', '武侠', '热门IP'],
    featured: false,
    isNew: true,
    isHot: true,
    content: '<p>《庆余年第二季》承接第一季的结尾，范闲在经历了一番生死考验后回到京都。朝堂局势更加诡谲多变，各方势力明争暗斗，范闲不得不在复杂的政治漩涡中寻找生存之道。</p><p>张若昀的演技更加纯熟，陈道明饰演的庆帝气场全开，两人的对手戏堪称教科书级别。吴刚饰演的陈萍萍也贡献了令人动容的表演。</p>',
    releaseDate: '2026-05-16',
  },
  {
    id: 5,
    title: '哪吒之魔童闹海',
    titleEn: 'Ne Zha 2',
    category: 'anime',
    categoryLabel: '动漫',
    year: 2025,
    rating: 9.2,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20featuring%20a%20mythical%20boy%20with%20flaming%20wheels%20and%20a%20red%20sash%20flying%20above%20the%20ocean%2C%20epic%20battle%20scene%2C%20vibrant%20colors%2C%20cinematic%20lighting%2C%20clean%20composition&width=600&height=840&seq=movie-poster-05&orientation=portrait',
    description: '天劫之后，哪吒和敖丙的灵魂虽保住，但肉身面临消散危机。太乙真人欲用七色宝莲重塑肉身，然而过程中遭遇重重困难，哪吒和敖丙的命运再次交织在一起。',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨'],
    region: '中国大陆',
    duration: '144分钟',
    status: '热播中',
    tags: ['动画', '神话', '动作', '国产动画'],
    featured: true,
    isNew: false,
    isHot: true,
    content: '<p>《哪吒之魔童闹海》是光线彩条屋影业出品的动画电影，延续了前作《哪吒之魔童降世》的世界观。影片在视觉效果上再次突破，每一帧画面都堪称艺术品。</p><p>饺子导演用独特的叙事方式重新诠释了中国传统神话故事，将"我命由我不由天"的精神内核贯穿始终，燃起了观众心中的热血与感动。</p>',
    releaseDate: '2025-07-18',
  },
  {
    id: 6,
    title: '极限挑战第十季',
    titleEn: 'Go Fighting Season 10',
    category: 'variety',
    categoryLabel: '综艺',
    year: 2026,
    rating: 8.3,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20featuring%20a%20group%20of%20celebrities%20in%20colorful%20casual%20outfits%20posing%20playfully%2C%20bright%20energetic%20colors%2C%20fun%20atmosphere%2C%20clean%20simple%20background&width=600&height=840&seq=movie-poster-06&orientation=portrait',
    description: '极限男人帮再度集结，全新的挑战任务，更刺激的冒险体验。黄渤、孙红雷、黄磊、罗志祥、王迅、张艺兴齐聚一堂，为观众带来欢笑与感动。',
    director: '严敏',
    actors: ['黄渤', '孙红雷', '黄磊', '王迅', '张艺兴'],
    region: '中国大陆',
    duration: '12期',
    episodes: 12,
    status: '热播中',
    tags: ['综艺', '真人秀', '搞笑', '挑战'],
    featured: false,
    isNew: true,
    isHot: false,
    content: '<p>《极限挑战第十季》延续了该系列一贯的搞笑与温情并存的风格。新一季加入了更多创新元素，挑战任务更加天马行空，嘉宾们之间的化学反应依旧精彩。</p><p>这一季的主题是"城市探险"，每期节目将带观众走进一个中国城市，在游戏中感受当地的文化魅力。</p>',
    releaseDate: '2026-04-10',
  },
  {
    id: 7,
    title: '封神第二部',
    titleEn: 'Creation of the Gods II',
    category: 'movie',
    categoryLabel: '电影',
    year: 2025,
    rating: 8.1,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20epic%20movie%20poster%20featuring%20ancient%20warriors%20riding%20mythical%20beasts%20in%20battle%2C%20grand%20scale%2C%20golden%20and%20crimson%20tones%2C%20dramatic%20lighting%2C%20clean%20composition&width=600&height=840&seq=movie-poster-07&orientation=portrait',
    description: '姜子牙率众神归位，封神大战全面爆发。殷寿的暴政激起天下义愤，姬发率领西岐大军挥师东进，一场决定天下命运的史诗大战拉开帷幕。',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰'],
    region: '中国大陆',
    duration: '150分钟',
    status: '已完结',
    tags: ['神话', '史诗', '动作', '奇幻'],
    featured: false,
    isNew: false,
    isHot: true,
    content: '<p>《封神第二部》延续了第一部建立的宏大世界观，战争场面更加震撼。乌尔善导演用史诗般的镜头语言，将中国古典神话搬上了大银幕。</p><p>费翔饰演的纣王殷寿气场强大，李雪健饰演的姬昌则展现了深沉的家国情怀。影片在视觉特效上达到了华语电影的顶尖水准。</p>',
    releaseDate: '2025-08-10',
  },
  {
    id: 8,
    title: '三体：黑暗森林',
    titleEn: 'Three-Body: The Dark Forest',
    category: 'tv',
    categoryLabel: '电视剧',
    year: 2026,
    rating: 9.1,
    poster: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20poster%20featuring%20a%20vast%20dark%20universe%20with%20stars%20and%20a%20mysterious%20cosmic%20structure%2C%20deep%20space%20vibe%2C%20minimalist%20design%2C%20cinematic%20lighting%2C%20clean%20composition&width=600&height=840&seq=movie-poster-08&orientation=portrait',
    description: '面对三体文明的入侵，人类启动了面壁计划。四位面壁者各自制定对抗三体的秘密战略，而三体人则在地球上寻找破壁人来破解这些计划。一场跨越光年的智慧较量就此展开。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    region: '中国大陆',
    duration: '30集',
    episodes: 30,
    status: '热播中',
    tags: ['科幻', '悬疑', '史诗', '刘慈欣'],
    featured: true,
    isNew: true,
    isHot: true,
    content: '<p>《三体：黑暗森林》改编自刘慈欣雨果奖获奖作品《三体》系列第二部。剧集完美还原了原著中宏大的宇宙观和深邃的哲学思考，是人类想象力的一次极致呈现。</p><p>面壁计划、黑暗森林法则、水滴探测器……这些经典元素被一一呈现。于和伟饰演的史强与张鲁一饰演的罗辑之间的互动，成为全剧最大的亮点之一。</p>',
    releaseDate: '2026-03-21',
  },
  {
    id: 9,
    title: '鬼灭之刃：无限城篇',
    titleEn: 'Demon Slayer: Infinity Castle',
    category: 'anime',
    categoryLabel: '动漫',
    year: 2025,
    rating: 9.3,
    poster: 'https://readdy.ai/api/search-image?query=Anime%20movie%20poster%20featuring%20a%20young%20swordsman%20with%20a%20katana%20in%20a%20surreal%20floating%20castle%2C%20dynamic%20action%20pose%2C%20vibrant%20red%20and%20dark%20tones%2C%20Japanese%20anime%20style%2C%20clean%20composition&width=600&height=840&seq=movie-poster-09&orientation=portrait',
    description: '炭治郎一行人被传入无限城，鬼舞辻无惨终于现身。上弦之鬼与鬼杀队的最强剑士们展开终极对决，每个人都赌上了生命。最终决战，一触即发。',
    director: '外崎春雄',
    actors: ['花江夏树', '鬼头明里', '下野纮', '松冈祯丞'],
    region: '日本',
    duration: '120分钟',
    status: '热播中',
    tags: ['动漫', '热血', '战斗', '日漫'],
    featured: false,
    isNew: true,
    isHot: true,
    content: '<p>《鬼灭之刃：无限城篇》是鬼灭之刃系列的最终章剧场版。ufotable倾尽全力打造的视觉盛宴，每一场战斗都令人叹为观止。</p><p>炭治郎与无惨的宿命对决、柱们与上弦之鬼的生死搏杀，每一帧画面都凝聚了制作组的心血。这不仅是鬼灭之刃的终章，更是日本动画史上的一个里程碑。</p>',
    releaseDate: '2025-12-05',
  },
  {
    id: 10,
    title: '奔跑吧第八季',
    titleEn: 'Keep Running Season 8',
    category: 'variety',
    categoryLabel: '综艺',
    year: 2026,
    rating: 7.9,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20featuring%20celebrities%20running%20and%20laughing%20in%20sportswear%2C%20dynamic%20action%20shot%2C%20bright%20sunny%20colors%2C%20energetic%20atmosphere%2C%20clean%20simple%20background&width=600&height=840&seq=movie-poster-10&orientation=portrait',
    description: '奔跑吧家族迎来全新阵容，李晨、郑恺、Angelababy携手新成员，开启全新的奔跑之旅。每期都有神秘嘉宾空降，爆笑挑战不停歇。',
    director: '姚译添',
    actors: ['李晨', '郑恺', 'Angelababy', '沙溢', '白鹿'],
    region: '中国大陆',
    duration: '12期',
    episodes: 12,
    status: '热播中',
    tags: ['综艺', '真人秀', '搞笑', '竞技'],
    featured: false,
    isNew: true,
    isHot: false,
    content: '<p>《奔跑吧第八季》以全新的主题和游戏设计回归，在保留经典撕名牌环节的同时，加入了更多创新的互动游戏。新成员的加入为节目注入了新鲜活力。</p><p>每一期节目都会选择不同的城市作为录制地点，让观众在欢笑中感受祖国的大好河山。</p>',
    releaseDate: '2026-06-06',
  },
  {
    id: 11,
    title: '奥本海默',
    titleEn: 'Oppenheimer',
    category: 'movie',
    categoryLabel: '电影',
    year: 2025,
    rating: 8.8,
    poster: 'https://readdy.ai/api/search-image?query=Dramatic%20biographical%20movie%20poster%20featuring%20a%20man%20in%20a%20fedora%20hat%20against%20a%20mushroom%20cloud%20silhouette%2C%20intense%20expression%2C%20black%20and%20orange%20tones%2C%20cinematic%20lighting%2C%20clean%20composition&width=600&height=840&seq=movie-poster-11&orientation=portrait',
    description: '聚焦"原子弹之父"罗伯特·奥本海默的传奇一生。从曼哈顿计划的辉煌成就，到战后道德困境的深渊挣扎，一个天才科学家的荣耀与悲剧交织的人生。',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    region: '美国',
    duration: '180分钟',
    status: '已完结',
    tags: ['传记', '历史', '剧情', '诺兰'],
    featured: false,
    isNew: false,
    isHot: false,
    content: '<p>诺兰用他标志性的非线性叙事手法，将奥本海默的内心世界呈现得淋漓尽致。影片不仅是一部传记片，更是对人类文明命运的深刻反思。</p><p>基里安·墨菲的表演堪称惊艳，他将奥本海默的智慧、矛盾与痛苦展现得入木三分。IMAX摄影机拍摄的震撼画面，让观众仿佛置身于那个改变世界的时代。</p>',
    releaseDate: '2025-03-11',
  },
  {
    id: 12,
    title: '全职猎人重制版',
    titleEn: 'Hunter x Hunter Remake',
    category: 'anime',
    categoryLabel: '动漫',
    year: 2026,
    rating: 9.4,
    poster: 'https://readdy.ai/api/search-image?query=Anime%20poster%20featuring%20a%20spiky%20haired%20boy%20with%20a%20fishing%20rod%20and%20three%20companions%2C%20adventure%20theme%2C%20vibrant%20green%20and%20blue%20colors%2C%20Japanese%20anime%20style%2C%20clean%20composition&width=600&height=840&seq=movie-poster-12&orientation=portrait',
    description: '小杰为了寻找父亲金，踏上了成为猎人的冒险旅程。在猎人考试中结识了奇犽、酷拉皮卡和雷欧力，四人结下了深厚的友谊。重制版以全新画质再现经典。',
    director: '神志那弘志',
    actors: ['潘惠美', '伊濑茉莉也', '泽城美雪', '藤原启治'],
    region: '日本',
    duration: '148集',
    episodes: 148,
    status: '更新中',
    tags: ['动漫', '冒险', '热血', '经典重制'],
    featured: false,
    isNew: true,
    isHot: false,
    content: '<p>《全职猎人重制版》以全新的4K画质重新演绎富坚义博的经典漫画。从猎人考试到贪婪之岛，再到嵌合蚁篇，每一个篇章都经过精心重制。</p><p>新版在保留原作精髓的同时，优化了战斗场面的表现力，让这部经典作品焕发出新的生命力。</p>',
    releaseDate: '2026-01-08',
  },
  {
    id: 13,
    title: '长相思',
    titleEn: 'Lost You Forever',
    category: 'tv',
    categoryLabel: '电视剧',
    year: 2025,
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20featuring%20a%20beautiful%20woman%20in%20flowing%20traditional%20hanfu%20dress%2C%20ethereal%20ancient%20Chinese%20aesthetic%2C%20soft%20pastel%20tones%2C%20dreamy%20atmosphere%2C%20clean%20composition&width=600&height=840&seq=movie-poster-13&orientation=portrait',
    description: '上古时代，人神妖混居。小夭流落大荒百年，历经艰险，在命运的安排下与几位重要的人相遇。亲情、友情、爱情的纠葛中，她逐渐揭开自己的身世之谜。',
    director: '秦榛',
    actors: ['杨紫', '张晚意', '邓为', '檀健次'],
    region: '中国大陆',
    duration: '39集',
    episodes: 39,
    status: '已完结',
    tags: ['古装', '爱情', '神话', '女性向'],
    featured: false,
    isNew: false,
    isHot: false,
    content: '<p>《长相思》改编自桐华同名小说，由杨紫领衔主演。剧集以精良的制作和细腻的情感刻画打动了无数观众。杨紫饰演的小夭灵动可爱又不失坚韧，展现了极强的角色塑造力。</p><p>剧中的服化道堪称精良，每一套造型都经过精心设计，完美呈现了上古神话世界的瑰丽与神秘。</p>',
    releaseDate: '2025-09-25',
  },
  {
    id: 14,
    title: '这就是街舞第六季',
    titleEn: 'Street Dance of China S6',
    category: 'variety',
    categoryLabel: '综艺',
    year: 2025,
    rating: 8.7,
    poster: 'https://readdy.ai/api/search-image?query=Dance%20competition%20show%20poster%20featuring%20dancers%20in%20dynamic%20street%20dance%20poses%2C%20urban%20style%2C%20neon%20colors%20and%20graffiti%20elements%2C%20energetic%20vibe%2C%20clean%20composition&width=600&height=840&seq=movie-poster-14&orientation=portrait',
    description: '全国顶尖街舞舞者汇聚一堂，四位明星队长带队展开激烈对决。Breaking、Popping、Locking、Hip-Hop，各种舞种轮番上阵，燃爆全场。',
    director: '陆伟',
    actors: ['王一博', '韩庚', '刘雨昕', '李承铉'],
    region: '中国大陆',
    duration: '12期',
    episodes: 12,
    status: '已完结',
    tags: ['综艺', '街舞', '竞技', '潮流'],
    featured: false,
    isNew: false,
    isHot: false,
    content: '<p>《这就是街舞第六季》再次刷新了街舞综艺的天花板。来自全国各地的顶尖舞者用身体说话，每一支舞蹈都是一件艺术品。</p><p>王一博作为队长展现了极强的舞蹈功底和专业素养，韩庚则带来了更加成熟的舞蹈理念。四位队长各具特色，让比赛充满了看点和悬念。</p>',
    releaseDate: '2025-08-30',
  },
  {
    id: 15,
    title: '沙丘2',
    titleEn: 'Dune: Part Two',
    category: 'movie',
    categoryLabel: '电影',
    year: 2025,
    rating: 8.6,
    poster: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20featuring%20a%20man%20in%20desert%20robes%20standing%20on%20a%20sand%20dune%20under%20twin%20moons%2C%20vast%20desert%20landscape%2C%20golden%20and%20teal%20tones%2C%20cinematic%20lighting%2C%20clean%20composition&width=600&height=840&seq=movie-poster-15&orientation=portrait',
    description: '保罗·厄崔迪斯与弗雷曼人联合，踏上了向毁灭他家族的人复仇的道路。他必须在挚爱与宇宙命运之间做出选择，阻止只有他能预见的可怕未来。',
    director: '丹尼斯·维伦纽瓦',
    actors: ['提莫西·查拉梅', '赞达亚', '丽贝卡·弗格森', '奥斯汀·巴特勒'],
    region: '美国',
    duration: '166分钟',
    status: '已完结',
    tags: ['科幻', '史诗', '冒险', '好莱坞'],
    featured: false,
    isNew: false,
    isHot: false,
    content: '<p>《沙丘2》是维伦纽瓦导演对弗兰克·赫伯特科幻经典的完美续写。影片在视觉上达到了令人窒息的美学高度，沙漠的浩瀚与神秘被展现得淋漓尽致。</p><p>提莫西·查拉梅和赞达亚的化学反应十足，新加入的奥斯汀·巴特勒饰演的菲德-罗萨更是让人过目难忘。这不仅仅是一部科幻片，更是一部关于命运与选择的史诗。</p>',
    releaseDate: '2025-02-28',
  },
  {
    id: 16,
    title: '间谍过家家第二季',
    titleEn: 'Spy x Family Season 2',
    category: 'anime',
    categoryLabel: '动漫',
    year: 2026,
    rating: 8.9,
    poster: 'https://readdy.ai/api/search-image?query=Anime%20poster%20featuring%20a%20family%20of%20three%20in%20elegant%20attire%20a%20man%20in%20suit%20woman%20in%20dress%20and%20a%20cute%20pink-haired%20girl%2C%20spy%20theme%2C%20warm%20colors%2C%20comedic%20atmosphere%2C%20clean%20composition&width=600&height=840&seq=movie-poster-16&orientation=portrait',
    description: '间谍父亲、杀手母亲、读心术女儿，这个奇特的家庭继续上演温馨又爆笑的日常。与此同时，东国与西国之间的暗流涌动，新的危机悄然逼近。',
    director: '古桥一浩',
    actors: ['江口拓也', '种崎敦美', '早见沙织'],
    region: '日本',
    duration: '25集',
    episodes: 25,
    status: '更新中',
    tags: ['动漫', '喜剧', '日常', '间谍'],
    featured: false,
    isNew: true,
    isHot: true,
    content: '<p>《间谍过家家第二季》延续了第一季的超高人气，黄昏、约尔和阿尼亚一家三口的奇妙日常让人捧腹大笑的同时又倍感温暖。</p><p>新一季加入了更多主线剧情，约尔的杀手身份和黄昏的间谍使命开始出现交集，让故事更具张力。阿尼亚的表情包依然是全剧的流量担当。</p>',
    releaseDate: '2026-04-05',
  },
];

export const categories = [
  { slug: 'all', label: '全部', icon: 'ri-layout-grid-line' },
  { slug: 'movie', label: '电影', icon: 'ri-film-line' },
  { slug: 'tv', label: '电视剧', icon: 'ri-tv-line' },
  { slug: 'variety', label: '综艺', icon: 'ri-live-line' },
  { slug: 'anime', label: '动漫', icon: 'ri-rocket-line' },
];

export const getMoviesByCategory = (category: string): Movie[] => {
  if (category === 'all') return allMovies;
  return allMovies.filter((m) => m.category === category);
};

export const getMovieById = (id: number): Movie | undefined => {
  return allMovies.find((m) => m.id === id);
};

export const getFeaturedMovies = (): Movie[] => {
  return allMovies.filter((m) => m.featured);
};

export const getNewMovies = (): Movie[] => {
  return allMovies.filter((m) => m.isNew);
};

export const getHotMovies = (): Movie[] => {
  return allMovies.filter((m) => m.isHot);
};

export const getRelatedMovies = (movie: Movie, count: number = 6): Movie[] => {
  return allMovies
    .filter((m) => m.id !== movie.id && (m.category === movie.category || m.tags.some((t) => movie.tags.includes(t))))
    .slice(0, count);
};